import React from 'react';
import PropTypes from 'prop-types';
import FormInputItem from '../control/FormInputItem';
import FormManager from '../FormManager';

const FormTableTotals = ({ columns, rows, form }) => {
  const renderColumns = () => {
    return columns.map((fieldName, index) => {
      const field = form[fieldName];

      if (field.aggregate) {
        const aggregateId = `${field.name}-aggregate`;

        if (!form[aggregateId]) {
          FormManager.warnFieldName(aggregateId);
          return <td key={aggregateId} />;
        }

        return (
          <td key={aggregateId}>
            <div className="control-wrapper">
              <FormInputItem
                noLabel
                controlId={form[aggregateId].identifier}
                field={form[aggregateId]}
                value={form[aggregateId].displayValue}
                calculated={true}
              />
            </div>
          </td>
        );
      }

      return <td key={`subtotal_${field.identifier}`} />;
    });
  };

  // Don't even render a subtotal row if there are no rows in the collection or the data is empty
  if (rows === 0) {
    return (
      <tbody>
        <tr />
      </tbody>
    );
  }

  return (
    <tbody>
      <tr className="subtotals">
        <td className="control-column" colSpan={3}>
          <div className="sig-wrap">
            <i className="zmdi zmdi-functions zmdi-hc-2x" />
          </div>
        </td>
        {renderColumns()}
      </tr>
    </tbody>
  );
};

FormTableTotals.defaultProps = {
  form: {},
};

FormTableTotals.propTypes = {
  columns: PropTypes.array.isRequired,
  form: PropTypes.object,
  rows: PropTypes.number.isRequired,
};

export default FormTableTotals;
